import { apiPostCustomBody } from "@/utils";

function updateAppointmentFormData(frsGuid, model, year) {
  //console.log("model: ", model);
  //console.log("model json: ", JSON.stringify(model));
  return apiPostCustomBody("drone/updateAppointmentForm?frsGuid=" + frsGuid + "&year=" + year, { JsonModel: JSON.stringify(model) });
}

export default {
  updateAppointmentFormData,
}
export {
  updateAppointmentFormData,
}



// WEBPACK FOOTER //
// ./src/utils/drone.js